export default "__VITE_ASSET__CHX7b6B8__"